// utils/notificationsGate.js
//
// The ONLY org-specific code in the Notifications feature — the port of
// legacy Services/NotificationsGate.cs.
//
// Everything else — the API endpoints, the roster, the import heuristics, the
// compose and history UI — is org-agnostic and scoped by OrgId. This gate
// exists solely so the feature can be trialled with one customer before it
// appears for everyone.
//
// Call sites — exactly two, and nothing else in the feature knows about any
// particular org:
//   • utils/portalNav.js — whether to render the nav item (group applet menu)
//   • app/notifications/page.js — deep-link guard, so hiding the menu entry
//     cannot be bypassed by typing the URL
//
// TO ENABLE FOR EVERY GROUP APPLET ORG: change isNotificationsEnabled's body
// to `return true;`. Nothing else in the feature needs to be touched, and no
// API deploy is required.
//
// Note this gates the GROUP APPLET menu only. Standard orgs have no
// Notifications entry at all — making the feature available there is a
// deliberate second decision, not a side effect of opening this gate.
//
// The server does not consult this: its endpoints are org-admin gated and
// every query is scoped by OrgId, so an ungated org could only ever reach its
// own (empty) roster. Keeping the gate client-side means graduating the
// feature needs no API deploy.

/** Orgs in the pilot. Empty once the feature graduates. */
// Legacy Services/NotificationsGate.cs lists the pilot org(s); the port adds
// ONE extra, the owner's tester org, so send-testing never happens on a live
// customer org. notificationsGate.test.js pins: every legacy id present, and
// nothing else beyond DEV_TEST_ORG_IDS. Removed 2026-09-08 (audit 12s item 2),
// restored 2026-09-09 on the owner's ruling — keep it.
const DEV_TEST_ORG_IDS = [
    'fwsu2rzsbekxrnkyriy2pw',  // Alicia Group Applet (owner's tester org)
];
const TRIAL_ORG_IDS = [
    'yv73yveausyeb2j0gknzq',   // CA CIMT 4
    ...DEV_TEST_ORG_IDS,
];
export { DEV_TEST_ORG_IDS };

export function isNotificationsEnabled(orgId) {
    if (!orgId || !String(orgId).trim()) return false;
    const id = String(orgId).trim().toLowerCase();
    return TRIAL_ORG_IDS.some(t => t.toLowerCase() === id);
}
